import { Text } from "@ui-kitten/components";
import { EventNoticeDetails } from "features/types";
import React, { useEffect, useState } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import eventBus from "utils/eventBus";
import EventNoticeIcon, { eventNoticeConfig } from "./EventNoticeIcon";
import Popover from "./Popover/Popover";

interface NoticeTagProps {
  type: EventNoticeDetails["type"];
  tag?: string;
  description?: string;
  shouldShowPopover?: boolean;
  onPress?: () => void;
}

const NoticeTag: React.FC<NoticeTagProps> = ({
  type,
  tag,
  description,
  shouldShowPopover = false,
  onPress,
}) => {
  const [visible, setVisible] = useState(false);

  // If the component is rendered inside a bottom sheet, hide the popover when the bottom sheet is scrolled
  useEffect(() => {
    eventBus.on("bottom-sheet-scroll", () => {
      setVisible(false);
    });
    return () => {
      eventBus.off("bottom-sheet-scroll", () => {
        setVisible(false);
      });
    };
  }, []);

  return (
    <Pressable
      onPress={(e) => {
        if (onPress) {
          onPress();
          return;
        }
        e.stopPropagation();
        shouldShowPopover && setVisible((visible) => !visible);
      }}
    >
      <Popover isOpen={visible} popoverText={description || ""}>
        <View
          className="rounded-md px-2 py-1"
          style={{
            borderColor: eventNoticeConfig.border[type],
            backgroundColor: eventNoticeConfig.backgroundColor[type],
          }}
        >
          <View className="flex-row items-center">
            <View className="mr-2">
              <EventNoticeIcon type={type} size={12} />
            </View>
            <Text
              numberOfLines={1}
              style={{ color: eventNoticeConfig.color[type] }}
            >
              {tag}
            </Text>
          </View>
        </View>
      </Popover>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  tagContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    paddingHorizontal: 8,
    borderRadius: 4,
  },
});
export default NoticeTag;
